import axios from "axios";

const API_BASE_URL = "https://api.astrotrader.xyz/";  // ✅ Use your live backend domain > NO /API
axios.defaults.withCredentials = true;
// Create an Axios instance with session authentication enabled
const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true, // Ensures cookies (session authentication) are sent
});

// Extract CSRF token from cookies
const getCsrfToken = () => {
  return document.cookie
    .split("; ")
    .find(row => row.startsWith("csrftoken="))
    ?.split("=")[1] || "";
};

// Fetch user profile
export const getUserProfile = async () => {
  try {
    const response = await api.get("/userprofile/");
    return response.data;
  } catch (error) {
    console.error("❌ Error fetching user profile:", error);
    throw error;
  }
};

// Logout user
export const logoutUser = async () => {
  try {
    await api.post(
      "/logout/",
      {},
      {
        headers: { "X-CSRFToken": getCsrfToken() },  // Send CSRF token
      }
    );
    console.log("✅ Logged out successfully.");
  } catch (error) {
    console.error("❌ Logout failed:", error);
  }
};

// Fetch affirmation by zodiac sign
export const getAffirmation = async (zodiacSign) => {
  try {
    const response = await api.get(`/affirmation/${zodiacSign}/`);
    return response.data;
  } catch (error) {
    console.error("❌ Error fetching affirmation:", error);
    throw error;
  }
};

export default api;
